<div #parallax class="parallax">
    <div class="parallax-inner">
        <h-svg-icon class="icon-hermes-logo" [name]="'hermes-logo'" />
    </div>
</div>
